import { useState } from "react"
import { EComboItemType } from "../../Enum/EComboItemType"
import { ComboEntity } from "../../Objects/Combo/ComboEntity"
import { ComboItemReference } from "../../Objects/Combo/ComboItemReference"
import { CatalogProductEntity } from "../../Objects/ProductsAndCatalogItems/CatalogProductEntity"

export const useCreateCombo = () => {
  const [combo, setCombo] = useState<ComboEntity | null>(null)

  const [items, setItems] = useState<ComboItemReference[]>([])

  const handleInitialValue = (data?: ComboEntity) => {
    if (data) {
      setCombo(data)
      
      setItems(data.items.map((item) => new ComboItemReference(item)))

      return
    }

    setCombo(null)

    setItems([])
  }

  const addProductItem = (id: number) => {
    setItems((prev) => [...prev, new ComboItemReference({ itemId: id, itemType: EComboItemType.Product, quantity: 1 })])
  }

  const addCatalogItemItem = (id: number) => {
    setItems((prev) => [...prev, new ComboItemReference({ itemId: id, itemType: EComboItemType.CatalogItem, quantity: 1 })])
  }

  const removeItem = (index: number) => setItems((prev) => prev.filter((_, i) => i !== index))

  const updateQuantity = (index: number, quantity: number) => {
    setItems((prev) => prev.map((item, i) => (i === index ? new ComboItemReference({ ...item, quantity }) : item)))
  }

  const handleSubmitForm = (catalogProductEntity: CatalogProductEntity) =>
    new ComboEntity({
      id: combo?.id,
      productId: combo?.productId,
      catalogProductEntity,
      items,
    })

  return { items, addProductItem, addCatalogItemItem, removeItem, updateQuantity, handleInitialValue, handleSubmitForm }
}
